
import { Component, Emit, Vue } from "vue-property-decorator";
import AddressFormGroup from "../../../form/AddressFormGroup.vue";
import { Address, AddressBody, AddressDescription, Nullable } from "@gsx/common";
import FormSelect from "../../../form/FormSelect.vue";
import ActionButton from "../../../../../../common/src/components/ActionButton.vue";
import Modal from "../../../../../../common/src/components/Modal.vue";

@Component({
    components: {
        AddressFormGroup,
        ActionButton,
        FormSelect,
        Modal,
    },
})
export default class AddAddressModal extends Vue {
    description: AddressDescription | null = null;
    address: Nullable<AddressBody> = {
        country: null,
        city: null,
        zipcode: null,
        state: null,
        streetAddress: null,
        coordinates: null,
    };

    get addressDescriptions(): AddressDescription[] {
        return Object.values(AddressDescription);
    }

    @Emit()
    submit(): Nullable<Address> {
        return {
            description: this.description,
            ...this.address,
        };
    }

    @Emit()
    close() {
        //
    }

    async onSubmit() {
        this.submit();
        this.close();
    }
}
